export type BreadCrumbsItem = {
	label: string;
	route: string | null;
	routeParams?: object;
};

export enum Role {
	Admin = 1,
	User = 2,
	Guest = 3,
	TrialUser = 5,
}

export interface CurrentUserType {
	firstName: string;
	lastName: string;
	email: string;
	permissionId?: number;
	isAgreementSigned: boolean;
	isCampaignFieldsSet: boolean;
	roleId: Role;
	claimsIds: number[] | null;
	phoneNumber: number;
	imageUrl: string;
	statusId: number;
	isCommunityAvailable: boolean;
	isCommunityInstructionCompleted: boolean;
	userId: number;
	sourceType: UserSourceType | null;
	modulesIds: ModulesEnum[];
}

export enum Claim {
	'FMR Explorer' = 1,
	Courses,
	'City Research',
	'Property Lookup',
	'Deal Calculator',
	'Deal Explorer',
	Messenger,
	Coaching = 13,
	Community = 14,
	'My Profile' = 1,
	CruzControl = 8,
	TenantFinder = 9,
	Vendors = 10,
	Vault = 11,
	AiAnalyze = 12,
}

export const DefaultGuestClaims = [
	Claim['FMR Explorer'],
	Claim.Courses,
	Claim['City Research'],
	Claim['Property Lookup'],
	Claim['Deal Calculator'],
	Claim['Deal Explorer'],
];

export type ChatUserType = {
	about: null;
	avatarUrl: string | null;
	displayName: string;
	nickName: string;
	userId: number;
	isAdmin: boolean;
	isBannedInChannel: boolean;
	email: string | null;
};

export type UploadProgressState = {
	progress: number;
	totalSize: number;
};

export type SelectOption = {
	label: string;
	value: string | number;
};

export type BaseIconType = {
	width?: number;
	height?: number;
	fill?: string;
	stroke?: string;
};

export enum UserSourceType {
	Webinar = 1,
	Organic = 2,
	Invitation = 3,
}

export enum ModulesEnum {
	MarketData = 1,
	DealTools = 2,
	AITools = 3,
	ExpertNetwork = 4,
}
